import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '/api';

// Aparte axios-instance ZONDER JWT interceptor.
// Voor publieke endpoints (magic links) waar we geen Authorization header willen sturen.
const publicApi = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

export default publicApi;
